import {ShowPayments} from './show-payments';

export default ShowPayments;
